import type { FormikProps } from 'formik';
import type { NestedFormikName } from './nestedFormikName';

export function fieldHasError<T>(
  formik: FormikProps<T>,
  name: keyof T | NestedFormikName,
): boolean {
  const { touched, error } = formik.getFieldMeta(name as string);

  return !!(touched && error);
}
